import { LoadingSpinner } from "@newsela/angelou";
import Image from "next/image";
import PropTypes from "prop-types";

import ChallengesWidget from "@/challenges/ChallengesTeacher/ChallengesWidget";
import challengeMonthBadge from "../../../../public/images/icons/challenge-monthly-badge.svg";
import challengeMonthIcon from "../../../../public/images/icons/challenge-monthly-icon.svg";
import {
  contentWrapper,
  titleCss,
  widgetsWrapper,
  widgetsGroup,
  leftWidgetCss,
  smallCss,
  studentsHeader,
  studentRowWrapper,
  studentRowNameWrapper,
  studentRowTokensWrapper,
  studentRowName,
  studentRowNameNumber,
  studentRowTokens,
  subTitleCss,
  topicHeader,
  topicsList,
  topicRowWrapper,
  topicRowLeftWrapper,
  topicRowTextWrapper,
  topicRowName,
  topicRowSubtextWrapper,
  topicRowSubtext,
  topicRowNameNumber,
  noDataAvailableCss,
} from "./ChallengesTeacherReport.style";

const propTypes = {
  data: PropTypes.any,
};

const ChallengesTeacherReport = ({ data }) => {
  const renderStudentRow = (student, index) => {
    return (
      <div key={index} css={studentRowWrapper}>
        <div css={studentRowNameWrapper}>
          <h2 css={studentRowNameNumber}>{index + 1}</h2>
          <p css={studentRowName}>{student?.name}</p>
        </div>
        <div css={studentRowTokensWrapper}>
          <Image src={challengeMonthIcon} width={16} height={16} />
          <p css={studentRowTokens}>{student?.earned_tokens}</p>
        </div>
      </div>
    );
  };

  const renderTopicRow = (topic, index) => {
    return (
      <div key={index} css={topicRowWrapper}>
        <div css={topicRowLeftWrapper}>
          <h2 css={topicRowNameNumber}>{index + 1}</h2>
          <div css={topicRowTextWrapper}>
            <p css={topicRowName}>{topic?.name}</p>
            <div css={topicRowSubtextWrapper}>
              <p css={topicRowSubtext}>{topic?.students} students</p>
              <p css={topicRowSubtext}>{topic?.reads} reads</p>
            </div>
          </div>
        </div>
        <img
          src={topic?.image?.url}
          width={64}
          height={48}
          style={{ borderRadius: 4 }}
        />
      </div>
    );
  };

  /*
  const renderAvgWidget = (item, type) => {
    const scoreTotal = item?.score_average - item?.school_score_average;
    const scoreText = scoreTotal === 0 ? 'This is the same as the school avg.' : `This is ${(item?.score_average / item?.school_score_average) * 100}% ${scoreTotal > 0 ? 'above' : 'bellow'} the school avg.`;
    return (
      <div css={avgWidgetWrapper}>
        <div css={avgLeftWrapper(item?.score_average * 100)}>
          <p css={avgTotalPercentageCss}><span css={avgTotalPercentageStrongCss}>{String(Math.floor(item?.score_average * 100))?.substring(0, 2)}</span>%</p>
        </div>
        <div css={avgRightWrapper}>
          <p css={avgWidgetScholl}>{scoreText}</p>
          <Badge
            flavor={Badge.flavor.solid}
            color={Badge.color.black}
            size={Badge.size.md}
            text={`${item?.qt_completed} ${type} completed`}
            __cssFor={{ root: badgeCss }}
            SvgIcon={type === 'Quiz' ? QuizSVG : PowerWordHollowSVG}
          />
        </div>
      </div>
    );
  };
  */

  return (
    <div css={contentWrapper}>
      {!data ? (
        <LoadingSpinner />
      ) : data === "no data" ? (
        <div css={noDataAvailableCss}>No data available.</div>
      ) : (
        <div css={widgetsWrapper}>
          <div css={widgetsGroup}>
            <ChallengesWidget>
              <div css={leftWidgetCss}>
                <Image src={challengeMonthIcon} />
                <h2 css={titleCss}>{data?.earned_tokens || 0}</h2>
              </div>
            </ChallengesWidget>
            <ChallengesWidget title="Badges earned">
              <div css={leftWidgetCss}>
                <Image src={challengeMonthBadge} />
                <h2 css={titleCss}>
                  {data?.badges_earned || 0}
                  <span css={smallCss}>/60</span>
                </h2>
                <p css={subTitleCss}>students</p>
              </div>
            </ChallengesWidget>
          </div>
          <ChallengesWidget title="Student leaderboard">
            <div css={studentsHeader}>
              <p>Student</p>
              <p>Tokens</p>
            </div>
            {data?.top_students
              ?.slice(0, 5)
              .map((student, index) => renderStudentRow(student, index))}
          </ChallengesWidget>
          <ChallengesWidget title="Leading topic">
            <div css={topicHeader}>
              <p>
                See how the topics for this month’s challenge rank amongst your
                students.
              </p>
              <div css={topicsList}>
                {data?.leading_topics?.map((topic, index) =>
                  renderTopicRow(topic, index),
                )}
              </div>
            </div>
          </ChallengesWidget>
          {/*
              The Avg. score for activities will be temporarily removed
              from Teacher Insights until we have successfully integrated
              with Nightingale as we've been facing many performance issues
              with the reporting API.
               */}
          {/*
              <div css={widgetsAvgGroup}>
                <ChallengesWidget title='Avg. Quiz score'>
                  {renderAvgWidget(data?.activity_report?.quiz, 'Quiz')}
                </ChallengesWidget>
                <ChallengesWidget title='Avg. Power Words score'>
                  {renderAvgWidget(data?.activity_report?.power_words, 'Power Words')}
                </ChallengesWidget>
              </div>
              */}
        </div>
      )}
    </div>
  );
};

ChallengesTeacherReport.propTypes = propTypes;

export default ChallengesTeacherReport;
